<template>
  <div class="home">
    <!-- <el-alert
            type="warning"
            center>
        <template slot="title">
            新版七尾狐仅支持查看2021.04.19日以来的数据，更多历史数据请前往 <el-link type="primary" @click="versionChange">旧版七尾狐</el-link>
        </template>
    </el-alert> -->
    <div class="header">
      <div class="header-inner">
        <el-row type="flex" justify="space-between" align="middle">
          <el-col class="logo-col">
            <img class="logo" src="../assets/qwh_only_logo.png" />
            <button class="head-menu-item active" type="button">
              交易分析
            </button>
            <NavMenu ref="navMenu" theme="dark" />
          </el-col>
          <el-col class="account">
            <UserMenu />
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="main-wrapper">
      <div class="main">
        <!-- 左侧 -->
        <div class="left-container">
          <div class="chart-box">
            <div class="chart-title" style="position: relative">
              账户盈亏
              <i
                class="el-icon-full-screen"
                style="
                  cursor: pointer;
                  position: absolute;
                  right: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                "
                @click="showFullscreenChart = true"
              ></i>
            </div>
            <HChart
              ref="accountProfitCard"
              class="sm-chart"
              id="accountProfit"
              :options="accountProfitOptions"
            />
          </div>
          <div class="chart-box">
            <div class="chart-title" style="position: relative">
              每周盈亏
              <i
                class="el-icon-full-screen"
                style="
                  cursor: pointer;
                  position: absolute;
                  right: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                "
                @click="showFullscreenWeekProfitChart = true"
              ></i>
            </div>
            <HChart
              ref="weekProfitCard"
              class="sm-chart"
              id="weekProfit"
              :options="weekProfitOptions"
            />
          </div>
        </div>
        <!-- 中间 -->
        <div class="center-container">
          <div class="chart-box">
            <div class="chart-title" style="position: relative">
              资产结构
              <i
                class="el-icon-full-screen"
                style="
                  cursor: pointer;
                  position: absolute;
                  right: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                "
                @click="showFullscreenStructChart = true"
              ></i>
            </div>
            <div class="center-box">
              <HChart
                ref="assetsStructCard"
                id="assetsStruct"
                :options="structOptions"
                height="400px"
              />
              <div class="money-box" v-if="hasStructData">
                <div class="title">总资产</div>
                <div class="number">
                  ￥
                  <countTo
                    :startVal="0"
                    :decimals="2"
                    :endVal="Number(assetTotal)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card-box">
            <div class="card">
              <span class="card-title">累计盈亏</span>
              <span
                class="number"
                :class="totalProfit > 0 ? 'positive' : 'negative'"
                >￥<countTo
                  :startVal="0"
                  :decimals="2"
                  :endVal="Number(totalProfit)"
              /></span>
            </div>
            <div class="card">
              <span class="card-title">今日盈亏</span>
              <span
                class="number"
                :class="todayProfit > 0 ? 'positive' : 'negative'"
                >￥<countTo
                  :startVal="0"
                  :decimals="2"
                  :endVal="Number(todayProfit)"
              /></span>
            </div>
          </div>
        </div>
        <!-- 右侧 -->
        <div class="right-container">
          <div class="chart-box">
            <div class="chart-title" style="position: relative">
              累计净值
              <i
                class="el-icon-full-screen"
                style="
                  cursor: pointer;
                  position: absolute;
                  right: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                "
                @click="showFullscreenNetWorthChart = true"
              ></i>
            </div>
            <HChart
              class="lg-chart"
              ref="netWorthCard"
              id="netWorth"
              :options="netWorthOptions"
            />
          </div>
          <div class="chart-box">
            <div class="chart-title" style="position: relative">
              盈亏曲线
              <i
                class="el-icon-full-screen"
                style="
                  cursor: pointer;
                  position: absolute;
                  right: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                "
                @click="showFullscreenProfitChart = true"
              ></i>
            </div>
            <HChart
              ref="profitCard"
              class="lg-chart"
              id="profit"
              :options="profitOptions"
            />
          </div>
        </div>
      </div>
      <div class="tabs">
        <el-row type="flex" justify="center">
          <el-col
            v-for="(item, index) in tabs"
            :key="item.id"
            :span="4"
            class="tab-box"
            @mouseenter.native="activeTab = index"
            @click.native="jumpToAnalysis(index)"
          >
            <div :class="activeTab === index ? 'tab active' : 'tab'">
              <img
                class="icon"
                :src="activeTab === index ? item.activeIcon : item.icon"
              />
            </div>
            <span :class="activeTab === index ? 'text active' : 'text'">{{
              item.text
            }}</span>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      title="账户盈亏"
      :visible.sync="showFullscreenChart"
      fullscreen
      append-to-body
    >
      <HChart
        v-if="showFullscreenChart"
        stock
        wheel-zoom
        class="lg-chart"
        id="fullscreenAccountProfit"
        :options="fullscreenAccountProfitOptions"
        height="calc(100vh - 150px)"
      />
    </el-dialog>
    <el-dialog
      title="资产结构"
      :visible.sync="showFullscreenStructChart"
      fullscreen
      append-to-body
    >
      <div
        style="
          position: relative;
          height: calc(100vh - 150px);
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <HChart
          v-if="showFullscreenStructChart"
          class="lg-chart"
          id="fullscreenStructChart"
          :options="fullscreenStructOptions"
          height="calc(100vh - 150px)"
          style="width: 100%"
        />
        <div
          v-if="hasStructData"
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            pointer-events: none;
          "
        >
          <div
            style="
              font-size: 32px;
              color: #666666;
              text-shadow: 0 1px 4px rgba(23, 119, 255, 0.34);
              margin-bottom: 10px;
            "
          >
            总资产
          </div>
          <div
            style="
              font-size: 28px;
              color: #1777ff;
              text-shadow: 0 1px 4px rgba(23, 119, 255, 0.34);
            "
          >
            ￥
            <countTo :startVal="0" :decimals="2" :endVal="Number(assetTotal)" />
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="每周盈亏"
      :visible.sync="showFullscreenWeekProfitChart"
      fullscreen
      append-to-body
    >
      <HChart
        v-if="showFullscreenWeekProfitChart"
        stock
        wheel-zoom
        class="lg-chart"
        id="fullscreenWeekProfit"
        :options="fullscreenWeekProfitOptions"
        height="calc(100vh - 150px)"
      />
    </el-dialog>
    <el-dialog
      title="累计净值"
      :visible.sync="showFullscreenNetWorthChart"
      fullscreen
      append-to-body
    >
      <HChart
        v-if="showFullscreenNetWorthChart"
        stock
        wheel-zoom
        class="lg-chart"
        id="fullscreenNetWorth"
        :options="fullscreenNetWorthOptions"
        height="calc(100vh - 150px)"
      />
    </el-dialog>
    <el-dialog
      title="盈亏曲线"
      :visible.sync="showFullscreenProfitChart"
      fullscreen
      append-to-body
    >
      <HChart
        v-if="showFullscreenProfitChart"
        stock
        wheel-zoom
        class="lg-chart"
        id="fullscreenProfit"
        :options="fullscreenProfitOptions"
        height="calc(100vh - 150px)"
      />
    </el-dialog>
  </div>
</template>

<script>
import HChart from "@/components/HChart.vue";
import { Loading } from "element-ui";
import { mapState } from "vuex";
import countTo from "vue-count-to";
import { apiAnalysisData, apiGeneral } from "../api/analysis";
import UserMenu from "@/components/UserMenu.vue";
import NavMenu from "@/components/NavMenu.vue";

export default {
  name: "home",
  components: {
    UserMenu,
    NavMenu,
    HChart,
    countTo,
  },
  data() {
    return {
      showFullscreenStructChart: false,
      showFullscreenChart: false,
      showFullscreenWeekProfitChart: false,
      showFullscreenNetWorthChart: false,
      showFullscreenProfitChart: false,
      screenWidth: document.body.clientWidth,
      agreement: "",
      activeTab: 0,
      tabs: [
        // {
        //   id: 0,
        //   text: '资产概况',
        //   icon: require('../assets/home/assets.png'),
        //   activeIcon: require('../assets/home/assets_active.png')
        // },
        {
          id: 1,
          text: "综合统计",
          icon: require("../assets/home/total.png"),
          activeIcon: require("../assets/home/total_active.png"),
        },
        {
          id: 2,
          text: "收益分析",
          icon: require("../assets/home/income.png"),
          activeIcon: require("../assets/home/income_active.png"),
        },
        {
          id: 3,
          text: "交易特征",
          icon: require("../assets/home/trans.png"),
          activeIcon: require("../assets/home/trans_active.png"),
        },
        {
          id: 4,
          text: "品种分析",
          icon: require("../assets/home/single.png"),
          activeIcon: require("../assets/home/single_active.png"),
        },
        {
          id: 5,
          text: "原始数据",
          icon: require("../assets/home/origin.png"),
          activeIcon: require("../assets/home/origin_active.png"),
        },
        {
          id: 6,
          text: "账户管理",
          icon: require("../assets/home/account.png"),
          activeIcon: require("../assets/home/account_active.png"),
        },
        // {
        //   id: 8,
        //   text: 'K线复盘',
        //   icon: require('../assets/home/kline.png'),
        //   activeIcon: require('../assets/home/kline_active.png')
        // }
      ],
      assetTotal: 0,
      totalProfit: 0,
      todayProfit: 0,
      weekProfitOptions: {
        credits: {
          enabled: false,
        },
        chart: {
          renderTo: "container",
          type: "column",
          options3d: {
            enabled: true,
            alpha: 5,
            beta: 0,
            depth: 20,
            viewDistance: 90,
          },
          margin: [40, 20, 75, 70],
          height: 280,
          backgroundColor: null,
          plotBackgroundColor: null,
        },
        title: {
          text: "",
          y: 16,
          style: {
            fontSize: "18px",
            fontWeight: 400,
            color: "#DEF1FF",
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {},
        colors: ["#ff2d2e"],
        plotOptions: {
          series: {
            negativeColor: "#00933b",
          },
        },
        xAxis: {
          categories: [],
          lineWidth: 1,
          gridLineWidth: 0,
          labels: {
            style: {
              fontFamily: "PingFang SC",
              fontWeight: 500,
              color: "#999999",
            },
          },
        },
        yAxis: {
          // tickAmount: 4,
          gridLineWidth: 1,
          gridLineColor: "rgba(101, 198, 231, 0.2)",
          labels: {
            style: {
              color: "#999999",
            },
          },
          title: {
            text: "",
          },
        },
        series: [
          {
            name: "每周盈亏",
            data: [],
            color: {
              linearGradient: [0, 0, 0, 140],
              stops: [
                [0, "#01F0FF"],
                [1, "#005559"],
              ],
            },
          },
        ],
      },
      structOptions: {
        credits: {
          enabled: false,
        },
        chart: {
          type: "pie",
          margin: [0, 0, 0, 0],
          height: 400,
          backgroundColor: null,
          plotBackgroundColor: null,
        },
        colors: ["#3240ff", "#3c91ff", "#48e3ff", "#0cffdb"],
        title: {
          floating: true,
          text: "",
        },
        tooltip: {
          pointFormat:
            "资产：<b>{point.y}</b><br/>{series.name}: <b>{point.percentage:.2f}%</b>",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 25,
            innerSize: "50%",
            dataLabels: {
              enabled: false,
              format: "{point.name}",
            },
          },
        },
        series: [],
      },
      accountProfitOptions: {
        credits: {
          enabled: false,
        },
        chart: {
          renderTo: "container",
          type: "column",
          options3d: {
            enabled: true,
            alpha: 5,
            beta: 0,
            depth: 20,
            viewDistance: 90,
          },
          margin: [40, 20, 75, 70],
          height: 280,
          backgroundColor: null,
          plotBackgroundColor: null,
        },
        title: {
          text: "",
          y: 16,
          style: {
            fontSize: "18px",
            fontWeight: 400,
            color: "#DEF1FF",
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {},
        colors: ["#ff2d2e"],
        plotOptions: {
          series: {
            negativeColor: "#00933b",
          },
        },
        xAxis: {
          categories: [],
          lineWidth: 1,
          gridLineWidth: 0,
          labels: {
            style: {
              fontFamily: "PingFang SC",
              fontWeight: 500,
              color: "#999999",
            },
          },
        },
        yAxis: {
          // tickAmount: 4,
          gridLineWidth: 1,
          gridLineColor: "rgba(101, 198, 231, 0.2)",
          labels: {
            style: {
              color: "#999999",
            },
          },
          title: {
            text: "",
          },
        },
        series: [
          {
            name: "账户盈亏",
            data: [],
            color: {
              linearGradient: [0, 0, 0, 140],
              stops: [
                [0, "#01F0FF"],
                [1, "#005559"],
              ],
            },
          },
        ],
      },
      netWorthOptions: {
        credits: {
          enabled: false,
        },
        title: {
          text: "",
          y: 16,
          x: 12,
          style: {
            fontSize: "18px",
            fontWeight: 400,
            color: "#DEF1FF",
          },
        },
        chart: {
          type: "spline",
          zoomType: "x",
          margin: [40, 20, 75, 60],
          height: 280,
          backgroundColor: null,
          plotBackgroundColor: {
            linearGradient: [0, 0, 0, 250],
            stops: [
              [0, "#FFFFFF"],
              [1, "#E7ECF8"],
            ],
          },
        },
        colors: ["#2165F9"],
        xAxis: {
          labels: {
            style: {
              color: "#999999",
            },
          },
          lineWidth: 0,
          categories: [],
        },
        yAxis: {
          visible: true,
          gridLineWidth: 1,
          min: 1,
          gridLineColor: "rgba(101, 198, 231, 0.2)",
          labels: {
            style: {
              color: "#999999",
            },
          },
          title: {
            text: "",
          },
        },
        tooltip: {},
        legend: {
          enabled: false,
        },
        series: [
          {
            name: "累计净值",
            data: [],
          },
        ],
      },
      profitOptions: {
        credits: {
          enabled: false,
        },
        title: {
          text: "",
          y: 16,
          x: 12,
          style: {
            fontSize: "18px",
            fontWeight: 400,
            color: "#DEF1FF",
          },
        },
        chart: {
          type: "line",
          zoomType: "x",
          margin: [40, 20, 75, 60],
          height: 280,
          backgroundColor: null,
          plotBackgroundColor: {
            linearGradient: [0, 0, 0, 250],
            stops: [
              [0, "#FFFFFF"],
              [1, "#E7ECF8"],
            ],
          },
        },
        colors: ["#FF5A82", "#2165F9"],
        xAxis: {
          labels: {
            style: {
              color: "#999999",
            },
          },
          lineWidth: 0,
          categories: [],
        },
        yAxis: {
          visible: true,
          gridLineWidth: 1,
          gridLineColor: "rgba(101, 198, 231, 0.2)",
          labels: {
            style: {
              color: "#999999",
            },
          },
          title: {
            text: "",
          },
        },
        tooltip: {},
        legend: {
          align: "center",
          verticalAlign: "top",
        },
        series: [
          {
            type: "line",
            name: "累计收益",
            lineColor: "rgba(4,205,244, 0.7)",
            color: {
              linearGradient: [0, 120, 0, 0],
              stops: [
                [0, "rgba(4,205,244,0)"],
                [1, "rgba(4,205,244,1)"],
              ],
            },
            data: [],
          },
          {
            type: "line",
            name: "累计手续费",
            lineColor: "rgba(43, 128, 255, 0.7)",
            color: {
              linearGradient: [0, 120, 0, 0],
              stops: [
                [0, "rgba(43, 128, 255, 0)"],
                [1, "rgba(43, 128, 255, 1)"],
              ],
            },
            data: [],
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
    hasStructData() {
      return (this.structOptions.series || []).some(
        (series) => (series.data || []).length > 0,
      );
    },
    fullscreenAccountProfitOptions() {
      return this.buildFullscreenRangeChartOptions(this.accountProfitOptions);
    },
    fullscreenStructOptions() {
      let options = JSON.parse(JSON.stringify(this.structOptions));
      if (options.chart) {
        options.chart.height = null;
        options.chart.spacing = [40, 140, 40, 140];
      }
      options.plotOptions = {
        ...(options.plotOptions || {}),
        pie: {
          ...((options.plotOptions && options.plotOptions.pie) || {}),
          dataLabels: {
            ...((options.plotOptions &&
              options.plotOptions.pie &&
              options.plotOptions.pie.dataLabels) ||
              {}),
            enabled: true,
            distance: 40, // 数据标签与饼图中心的距离
            allowOverlap: true,
            connectorWidth: 1,
            connectorColor: "#999999",
            crop: false,
            overflow: "allow",
            format: "{point.name}",
            style: {
              color: "#333333",
              fontSize: "14px",
              fontWeight: "400",
              textOutline: "none",
            },
          },
        },
      };
      options.series = (options.series || []).map((series) => ({
        ...series,
        size: "90%",
        innerSize: "50%",
      }));
      return options;
    },
    fullscreenWeekProfitOptions() {
      return this.buildFullscreenRangeChartOptions(this.weekProfitOptions);
    },
    fullscreenNetWorthOptions() {
      return this.buildFullscreenRangeChartOptions(this.netWorthOptions);
    },
    fullscreenProfitOptions() {
      return this.buildFullscreenRangeChartOptions(this.profitOptions);
    },
  },
  beforeCreate() {
    if (
      this.$store.state.curAccountId.length === 0 &&
      this.$store.state.accounts.length > 0
    ) {
      let curAccount = this.$store.state.accounts[0];
      this.$store.commit("SET_CUR_ACCOUNT_ID", [curAccount.id]);
    }
  },
  mounted() {
    this.$store.commit("SET_ANALYSIS_TYPE", "single");
    if (this.$store.state.accounts.length > 0) {
      let curAccount = this.$store.state.accounts[0];
      this.$store.commit("SET_CUR_ACCOUNT_ID", [curAccount.id]);
    } else {
      this.showNoAccountTip();
    }
    this.getData();
    this.getGeneralData();
  },
  methods: {
    // 无账户时提示，可直接前往账户管理页
    showNoAccountTip() {
      this.$confirm("请先添加期货监控中心账户或等待数据更新", "提示", {
        confirmButtonText: "去添加",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({ name: "Account" });
        })
        .catch(() => {});
    },
    buildFullscreenRangeChartOptions(baseOptions) {
      const options = JSON.parse(JSON.stringify(baseOptions));
      const baseChart = options.chart || {};
      const categories = (options.xAxis && options.xAxis.categories) || [];
      const labelFormatter = function () {
        const category = categories[Math.round(this.value)];
        return category === undefined ? this.value : category;
      };
      const formatTooltipNumber = (value) => {
        if (value === null || value === undefined || value === "") {
          return value;
        }
        const parts = String(value).split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        return parts.join(".");
      };
      const tooltipFormatter = function () {
        const label = categories[Math.round(this.x)] || this.key || this.x;
        const point = this.point || {};
        const color = point.color || (this.series && this.series.color);
        const value = formatTooltipNumber(this.y);
        return [
          `<span style="font-size: 10px">${label}</span><br/>`,
          `<span style="color:${color}">\u25CF</span> `,
          `${this.series.name}: <b>${value}</b><br/>`,
        ].join("");
      };
      options.chart = {
        ...baseChart,
        height: null,
        zoomType: "x",
        panning: true,
        panKey: "shift",
      };
      options.rangeSelector = {
        enabled: false,
      };
      options.navigator = {
        enabled: true,
        height: 45,
        margin: 18,
        maskFill: "rgba(23, 119, 255, 0.16)",
        outlineColor: "rgba(23, 119, 255, 0.4)",
        handles: {
          backgroundColor: "#1777ff",
          borderColor: "#1777ff",
        },
        xAxis: {
          categories,
          labels: {
            formatter: labelFormatter,
            style: {
              color: "#999999",
            },
          },
        },
      };
      options.scrollbar = {
        enabled: true,
        barBackgroundColor: "rgba(23, 119, 255, 0.25)",
        barBorderColor: "rgba(23, 119, 255, 0.25)",
        buttonBackgroundColor: "#ffffff",
        buttonBorderColor: "rgba(23, 119, 255, 0.4)",
        rifleColor: "#1777ff",
        trackBackgroundColor: "rgba(23, 119, 255, 0.08)",
        trackBorderColor: "rgba(23, 119, 255, 0.18)",
      };
      options.tooltip = {
        ...(options.tooltip || {}),
        split: false,
        formatter: tooltipFormatter,
      };
      options.xAxis = {
        ...(options.xAxis || {}),
        categories,
        minRange: 1,
        labels: {
          ...((options.xAxis && options.xAxis.labels) || {}),
          formatter: labelFormatter,
        },
      };
      options.plotOptions = {
        ...(options.plotOptions || {}),
        series: {
          ...((options.plotOptions && options.plotOptions.series) || {}),
          dataGrouping: {
            enabled: false,
          },
        },
      };
      return options;
    },
    getData() {
      // 无账户时直接展示空状态
      if (this.$store.state.accounts.length === 0) {
        return false;
      }
      let accounts = [];
      this.$store.state.accounts.map((item) => {
        accounts.push(item.id);
      });
      const params = {
        a_id: accounts.join(","),
        type: accounts.length === 1 ? "single" : "multiple",
        // b_date: this.$store.state.dateRange.b_date,
        // e_date: this.$store.state.dateRange.e_date,
      };
      let loadingWeekProfitCard = Loading.service({
        target: "#weekProfit",
        background: "rgba(0,0,0,0.1)",
      });
      apiAnalysisData("weekProfit", params).then((res) => {
        if (res.data.code === 0 && res.data.data) {
          let options = JSON.parse(JSON.stringify(this.weekProfitOptions));
          const resData = JSON.parse(JSON.stringify(res.data.data));
          let categories = [];
          let f1s = [];
          Array.isArray(resData) &&
            resData.map((item) => {
              categories.push(item.rq);
              if (item.f1 || item.f1 === 0) {
                f1s.push(item.f1);
              }
            });
          options.xAxis.categories = categories;
          options.series = [
            {
              name: "周盈亏",
              data: f1s,
            },
          ];
          this.weekProfitOptions = options;
        }
        loadingWeekProfitCard.close();
      });
      let loadingNetValue = Loading.service({
        target: "#netWorth",
        background: "rgba(0,0,0,0.1)",
      });
      apiAnalysisData("netValue", params).then((res) => {
        if (res.data.code === 0 && res.data.data) {
          let options = JSON.parse(JSON.stringify(this.netWorthOptions));
          const resData = JSON.parse(JSON.stringify(res.data.data));
          let categories = [];
          let f1s = [];
          Array.isArray(resData) &&
            resData.map((item) => {
              if (item.date) {
                categories.push(item.date);
              }
              if (item.f1 || item.f1 === 0) {
                f1s.push(item.f1);
              }
            });
          options.xAxis.categories = categories;
          options.series = [
            {
              name: "累计净值",
              data: f1s,
            },
          ];
          options.yAxis.min = Math.min(...f1s);
          options.yAxis.max = Math.max(...f1s);
          this.netWorthOptions = options;
        }
        loadingNetValue.close();
      });
      let loadingProfit = Loading.service({
        target: "#profit",
        background: "rgba(0,0,0,0.1)",
      });
      apiAnalysisData("profitCurve", params).then((res) => {
        if (res.data.code === 0 && res.data.data) {
          let options = JSON.parse(JSON.stringify(this.profitOptions));
          const resData = JSON.parse(JSON.stringify(res.data.data));
          let categories = [];
          let f1s = [];
          let f2s = [];
          Array.isArray(resData) &&
            resData.map((item) => {
              if (item.date) {
                categories.push(item.date);
              }
              if (item.f1 || item.f1 === 0) {
                f1s.push(item.f1);
              }
              if (item.f2 || item.f2 === 0) {
                f2s.push(item.f2);
              }
            });
          options.xAxis.categories = categories;
          options.series = [
            {
              name: "累计盈亏",
              data: f1s,
            },
            {
              name: "累计手续费",
              data: f2s,
            },
          ];
          this.profitOptions = options;
        }
        loadingProfit.close();
      });
    },
    async getGeneralData() {
      // 无账户时直接展示空状态
      if (this.$store.state.accounts.length === 0) {
        return false;
      }
      let loadingAssetsStruct = Loading.service({
        target: "#assetsStruct",
        background: "rgba(0,0,0,0.1)",
      });
      let loadingMonthProfit = Loading.service({
        target: "#accountProfit",
        background: "rgba(0,0,0,0.1)",
      });
      let res = await apiGeneral();
      if (res.data.code === 0 && res.data.data) {
        const resData = res.data.data;
        const {
          asset_total,
          today_profit,
          total_profit,
          asset_struct,
          account_profit,
        } = resData;
        let categories = [];
        let seriesData = [];
        let pieData = [];
        for (const key in account_profit) {
          const userAccount = this.$store.state.accounts.filter(
            (item) => item.id === Number(key),
          );
          if (userAccount[0]) {
            categories.push(userAccount[0].nickname);
            seriesData.push(account_profit[key]);
          }
        }
        for (const key in asset_struct) {
          const userAccount = this.$store.state.accounts.filter(
            (item) => item.id === Number(key),
          );
          if (userAccount[0]) {
            pieData.push([userAccount[0].nickname, asset_struct[key]]);
          }
        }
        this.assetTotal = asset_total;
        this.todayProfit = today_profit;
        this.totalProfit = total_profit;
        let structOptions = JSON.parse(JSON.stringify(this.structOptions));
        structOptions.series = [
          {
            type: "pie",
            name: "占比",
            radius: ["30%", "70%"],
            data: pieData,
          },
        ];
        this.structOptions = structOptions;

        let profitOptions = JSON.parse(
          JSON.stringify(this.accountProfitOptions),
        );
        profitOptions.xAxis.categories = categories;
        profitOptions.series = [
          {
            name: "盈亏",
            data: seriesData,
          },
        ];
        this.accountProfitOptions = profitOptions;
      }
      loadingAssetsStruct.close();
      loadingMonthProfit.close();
    },
    jumpToAnalysis(index) {
      switch (index + 1) {
        case 0:
          this.$router.push({ path: "/general" });
          break;
        case 1:
          this.$router.push({ path: "/analysis/report" });
          break;
        case 2:
          this.$router.push({ path: "/analysis/netValue" });
          break;
        case 3:
          this.$router.push({ path: "/analysis/takeCycle" });
          break;
        case 4:
          this.$router.push({ path: "/analysis/singleVariety" });
          break;
        case 5:
          this.$router.push({ path: "/analysis/dailySett" });
          break;
        case 6:
          this.$router.push({ path: "/account" });
          break;
        case 7:
          this.$refs.navMenu.openFDS();
          break;
        case 8:
          this.$router.push({ path: "/analysis/kline" });
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  margin: 0;
  min-width: 100%;
  width: fit-content;
  box-sizing: border-box;
  background-color: #f5f5f5;
  padding: 0 0 30px;

  .header {
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: url("../assets/home/header_bg.png") no-repeat;
    background-size: 100% 100%;
    color: #fff;
    font-weight: bolder;

    .header-inner {
      width: 1400px;
      height: 60px;
      margin: 0 auto;
    }

    .logo-col {
      display: flex;
      align-items: center;

      .logo {
        height: 50px;
        width: auto;
      }

      .head-menu-item {
        margin-left: 28px;
        padding: 0;
        border: 0;
        background: transparent;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        line-height: 60px;
        cursor: pointer;

        &.active {
          color: #e25840;
          text-decoration: underline;
          text-decoration-color: #e25840;
          text-decoration-thickness: 2px;
          text-underline-offset: 8px; /* 往下偏移，越大离文字越远 */
        }

        &:hover {
          color: #e25840dc;
        }
      }
    }

    .title-col {
      display: flex;
      align-items: center;
      justify-content: center;

      .title {
        width: 347px;
        height: 31px;
      }
    }

    .account {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      ::v-deep(.el-dropdown) {
        height: 40px;
        display: flex;
        align-items: center;

        .text {
          cursor: pointer;
          padding: 0 5px;
          margin-right: 10px;
          height: 40px;
          font-size: 16px;
          line-height: 40px;
          background-size: contain;
          display: flex;
          align-items: center;

          i {
            margin-top: -2px;
            font-size: 24px;
            color: #fff;
            line-height: 40px;
          }

          &:hover {
            color: #fff;
          }

          &:hover i {
            color: #ffffff;
          }
        }
      }
    }
  }

  .main-wrapper {
    width: 1400px;
    margin: 0 auto;
  }

  .main {
    flex: 1;
    padding: 20px 0px;
    display: flex;
    justify-content: space-between;
    gap: 20px;

    .left-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .center-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 20px;
      .center-box {
        width: 100%;
        height: 400px;
        padding: 20px 0;
        position: relative;

        .money-box {
          width: fit-content;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 16px;
          font-weight: 400;
          color: #666666;
          text-shadow: 0 1px 4px rgba(23, 119, 255, 0.34);

          .title {
            font-size: 24px;
          }

          .number {
            color: #1777ff;
          }
        }
      }
    }

    .right-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .card-box {
      width: 100%;
      height: 160px;
      display: flex;
      justify-content: space-between;
      gap: 20px;

      .card {
        flex: 1;
        padding: 20px 0;
        background: #ffffff;
        box-shadow: 0 0 16px 0 rgba(15, 41, 87, 0.1);
        border-radius: 4px;
        color: #333333;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;

        .card-title {
          font-size: 16px;
          font-weight: 400;
        }

        .number {
          &.positive {
            color: #aa0000;
          }

          &.negative {
            color: #10d142;
          }
        }
      }
    }

    .sm-chart {
      background: #ffffff;
      box-shadow: 0 0 16px 0 rgba(15, 41, 87, 0.1);
      border-radius: 4px;
    }

    .chart-box {
      width: 100%;
      height: fit-content;
      background: #ffffff;
      box-shadow: 0 0 16px 0 rgba(15, 41, 87, 0.1);
      border-radius: 4px;

      .chart-title {
        width: 100%;
        height: 40px;
        background: #1777ff;
        border-radius: 4px 4px 0 0;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        line-height: 40px;
      }

      .lg-chart {
        /*background: #FFFFFF;*/
        /*box-shadow: 0 0 16px 0 rgba(15, 41, 87, 0.1);*/
        /*border-radius: 4px;*/
      }
    }
  }

  .tabs {
    width: 100%;
    min-width: 800px;
    height: 140px;
    margin: 40px auto 10px;

    .tab-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      cursor: pointer;

      .tab {
        width: 115px;
        height: 115px;
        background: #ffffff;
        box-shadow: 0 2px 10px 0 rgba(20, 105, 226, 0.2);
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.active {
          background-color: #1777ff;
        }

        .icon {
          width: 45px;
          height: 45px;
        }
      }

      .text {
        font-size: 18px;
        line-height: 20px;
        margin: 20px 0;
        font-weight: 400;
        color: #1777ff;
      }
    }
  }
}
</style>
<style lang="scss">
.mt10 {
  margin-top: 10px;
}

.mt20 {
  margin-top: 20px;
}

.home {
  .cycle {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("../assets/home/ring_bg.png") no-repeat center 8px;
    background-size: 344px 290px;

    .el-progress-circle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 71% !important;
      height: 71% !important;
      margin: auto;
    }
  }

  .el-progress path:first-child {
    stroke: rgba(251, 254, 255, 0);
  }
}

.account-menu {
  /*background: rgba(0, 105, 211, 0.7);*/
  /*color: #00F6FF;*/
  /*border: none;*/
  /*border-radius: 4px;*/
}
</style>
